export const BOT_TOKEN = "7463566918:AAFuAtRkicazaHq9MX_tH_lYudpTn69nu70";
export const CHAT_ID = -1002233420153;
export const BOT_URL = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
export const BOT_URL_PHOTO = `https://api.telegram.org/bot${BOT_TOKEN}/sendPhoto`;
export const BOT_URL_MEDIA_GROUP = `https://api.telegram.org/bot${BOT_TOKEN}/sendMediaGroup`;
